import * as React from "react";
import { dbQueries, GetPage, StoredUser } from "duck";
import { UserRoleEnum } from "requests";
import AutoComplete from "../base";
import { AutoCompleteProps } from "../base/AutoComplete";

interface UsersProps<TMulti extends boolean = false>
  extends Omit<AutoCompleteProps<StoredUser, TMulti>, "getPage"> {
  role?: UserRoleEnum[];
}

const Users = <TMulti extends boolean = false>({
  role,
  ...props
}: UsersProps<TMulti>) => {
  const getPage = React.useCallback<GetPage<StoredUser, number>>(
    (_, variables) => dbQueries.loadUsers({ ...variables, role }),
    [role]
  );
  return (
    <AutoComplete<StoredUser, TMulti, any>
      getPage={getPage}
      optionLabel={user => `${user.firstName} ${user.lastName}`}
      {...props}
    />
  );
};

export default Users;
